import { Layout } from "antd";
import MenuLateralRadar from "radar/components/menu-lateral-radar";
import "./LayoutRadar.scss";

const { Content } = Layout;
const LayoutRadar: React.FC = (props) => {
  const { children } = props;

  return (
    <Layout className="layout-radar">
      <Layout>
        <MenuLateralRadar />
        <Content>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default LayoutRadar;
